import { useEffect, useState } from 'react';
import { BiMenu } from 'react-icons/bi';
import { ImCog } from 'react-icons/im';
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { useSystemContext } from '../Context/SystemContext';
import Layout from '../Layout/Layout';
import Grid from '../components/Grid';
import { CheckBoxInput, DBSelectInput, DateInputBR, DropDownProcessosinput, GroupInput, Input, SelectInput } from '../components/Input';
import { dateToString } from '../helper/dates';
import { periodos } from './CadastroEmpresa';

const yup = require('../interface/yup-br');

const Cadastros = () => {
    const System = useSystemContext();
    let navigate = useNavigate();
    const [Menu, setMenu] = useState(1);
    const [company, setCompany] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                let c = await System.methods.getCompany(); //System.property.company;
                setCompany(c);
            } catch (error) {
                console.log(error);
            }
        })();
        // eslint-disable-next-line
    }, []);


    function MenuEsquerdo() {
        return (
            <div className="ml-2 rounded w-72 bg-yellow-50">
                <div className="inline-flex w-full pl-2 mt-4 text-xl rounded-t h-7 bg-fundo-grupo-menu-lateral text-fonte-grupo-menu-lateral">
                    <BiMenu className="mt-1 mr-1" /> Cadastros
                </div>
                <div className="text-left border-b border-l border-r">
                    {System.methods.getUserRule('menuColaboradores') && (
                        <div
                            className={`w-full cursor-pointer inline-flex hover:bg-gray-300 ${Menu === 1 ? 'bg-gray-200' : 'bg-white'}`}
                            onClick={() => {
                                localStorage.removeItem('cache_crew');
                                localStorage.removeItem('cache_crewactive');
                                setMenu(1);
                            }}
                        >
                            <ImCog size="16" className="mt-1" /> <span className="pl-2 mt-1">Colaboradores</span>
                        </div>
                    )}
                    {System.methods.getUserRule('menuFuncoes') && (
                        <div
                            className={`w-full cursor-pointer inline-flex hover:bg-gray-300 ${Menu === 2 ? 'bg-gray-200' : 'bg-white'}`}
                            onClick={() => setMenu(2)}
                        >
                            <ImCog size="16" className="mt-1" /> <span className="pl-2 mt-1">Funções</span>
                        </div>
                    )}
                    {System.methods.getUserRule('menuProvedores') && (
                        <div
                            className={`w-full cursor-pointer inline-flex hover:bg-gray-300 ${Menu === 3 ? 'bg-gray-200' : 'bg-white'}`}
                            onClick={() => setMenu(3)}
                        >
                            <ImCog size="16" className="mt-1" /> <span className="pl-2 mt-1">Provedores Externos</span>
                        </div>
                    )}
                    {System.methods.getUserRule('menuTreinamentos') && (
                        <div
                            className={`w-full cursor-pointer inline-flex hover:bg-gray-300 ${Menu === 4 ? 'bg-gray-200' : 'bg-white'}`}
                            onClick={() => setMenu(4)}
                        >
                            <ImCog size="16" className="mt-1" /> <span className="pl-2 mt-1">Treinamentos</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    function TelaColaboradores() {
        return (
            <div className="mt-4 ml-2 bg-white grow">
                <div className="w-full border shadow">
                    <Grid
                        url={'/crew'}
                        canDelete={false}
                        canEdit={System.methods.getUserRule(`alterarColaboradores`)}
                        serverNoCache={true}
                        disableModal={true}
                        defaultSortField="createdAt"
                        forceReloadAfterSave
                        GridHeaders={[
                            { title: 'Id', field: 'identificacao', sort: true, className: 'w-1/12 text-left pl-1' },
                            { title: 'Nome', field: 'nome', sort: true, className: 'w-4/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Função', field: 'role', sort: true, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'E-mail', field: 'mail', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Admissão', field: 'admissao', sort: false, type: 'date', className: 'w-1/12 pl-1 text-left border-l border-r border-gray-300' },
                            { title: 'Master', field: 'master', sort: false, className: 'w-1/12 pl-1 text-center border-l border-r border-gray-300' },
                            {
                                title: 'Status', field: 'status', filter: {
                                    type: 'select',
                                    definition: [
                                        { value: 'Ativo', label: 'Ativo' },
                                        { value: 'Inativo', label: 'Inativo' },
                                    ],
                                }, sort: false, className: 'w-1/12 pl-1 text-center border-l border-r border-gray-300'
                            },
                        ]}
                        GridTitle="Lista de Colaboradores"
                        LineDataPrint={(data) => {
                            return [
                                data.identificacao,
                                data.nome,
                                data.funcao?.nome,
                                data.email,
                                dateToString(data.admissao),
                                data?.master ? '#color=blue:Master' : '',
                                data?.status,
                            ];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="nome" label="Nome" />
                                    <GroupInput>
                                        <Input name="identificacao" label="Identificação" />
                                        <DBSelectInput name="role" label="Função" url="/role" displaySelectField="nome" />
                                        <DateInputBR name="admissao" label="Admissão" />
                                    </GroupInput>
                                    <div className={'ml-2 mt-4 bg-amarelo-eq'}>Acesso ao Sistema</div>
                                    <GroupInput>
                                        <Input name="email" label="Email" type="email" className={'w-4/6'} />
                                        <Input name="senha" label="Senha" className={'w-2/6'} />
                                    </GroupInput>
                                    <GroupInput>
                                        {System.property.user.companyNorma &&
                                            <DropDownProcessosinput
                                                name="vinculoProcessos"
                                                label="Vinculo com Processos/Subprocessos"
                                                options={[
                                                    {
                                                        label: "Gerente e Gestão",
                                                        options: [
                                                            { label: "QSMS", option: "15fb0fd319df3b52df3fc205" },
                                                            { label: "Departamento Pessoal", option: "249adc110e2bfbfd10d668e4" },
                                                            { label: "Recursos Humanos", option: "35fb02d319df3b52df3fc205" },
                                                        ],
                                                    },
                                                    {
                                                        label: "CRM",
                                                        options: [
                                                            { label: "CRM (Petróleo Marítimo Comercial)", option: "45fb0fde19df3b52df3fc212" },
                                                        ],
                                                    },
                                                ]}
                                            />
                                        }
                                        <SelectInput
                                            name="status"
                                            label="Status colaborador"
                                            className={'inline-block'}
                                            listOptions={[{ value: 'Inativo' }, { value: 'Ativo' }]}
                                        />
                                        <div className="px-2 pt-3 mt-2 ml-4 mr-2 bg-yellow-200 border rounded shadow min-w-fit">
                                            <CheckBoxInput name="master" label="Usuário master" />
                                        </div>
                                    </GroupInput>
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            nome: yup.string().required('Nome é obrigatório'),
                            identificacao: yup.string().required('Identificação é obrigatório'),
                            role: yup.string().required('Função é obrigatório'),
                            admissao: yup.string().required('Admissão é obrigatório'),
                            email: yup.string(),
                            senha: yup.string(),
                            status: yup.string().required('Status é obrigatório'),
                            master: yup.boolean(),
                        })}
                    />
                </div>
            </div>
        );
    }

    function TelaFuncoes() {
        return (
            <>
                <div className="mt-4 ml-2 bg-white rounded grow">
                    <div className="w-full border shadow">
                        <Grid
                            url={'/role/' + System.property.company._id}
                            GridTitle="Funções dos Colaboradores"
                            canDelete={false}
                            canEdit={System.methods.getUserRule(`alterarFuncoes`)}
                            GridHeaders={[{ title: 'Nome da Função', field: 'nome', sort: true, className: 'w-full text-left pl-1' }]}
                            disableModal
                            forceReloadAfterSave
                            LineDataPrint={(data) => {
                                return [data.nome];
                            }}
                            validationSchema={yup.object().shape({
                                nome: yup.string().required('Nome da Função é obrigatória'),
                            })}
                            onRenderForm={(GridModes, SetFieldValue, values) => {
                                return (
                                    <div>
                                        <GroupInput>
                                            <Input name="nome" label="Nome da função" />
                                        </GroupInput>
                                    </div>
                                );
                            }}
                            FormTabs={[
                                () => {
                                    return <div>Home</div>;
                                },
                                () => {
                                    return <div>Matriz de Treinamentos</div>;
                                },
                            ]}
                            onRenderFormExtra={[
                                (GridModes, item, GridRefresh) => {
                                    // Treinamentos
                                    return (
                                        <div>
                                            <Grid
                                                url={`/treinamentofuncao/${item._id}`}
                                                key={uuid()}
                                                GridTitle="Treinamentos aplicados por função"
                                                canEdit={System.methods.getUserRule(`alterarFuncoes`)}
                                                canDelete={false}
                                                disableModal
                                                GridHeaders={[
                                                    { title: 'Treinamento', field: 'treinamento_id', sort: true, filter: true, className: 'w-1/2 text-left pl-1' },
                                                    { title: 'Periodicidade', field: 'periodicidade', sort: true, filter: true, className: 'w-1/2 text-left pl-1' },
                                                ]}
                                                LineDataPrint={(item) => {
                                                    return [
                                                        item?.treinamento?.treinamento || '',
                                                        periodos.find((x) => x.value === item?.treinamento?.periodicidade)?.option || '',
                                                    ];
                                                }}
                                                onRenderForm={(GridModes, SetFieldValue, values) => {
                                                    return (
                                                        <GroupInput>
                                                            <DBSelectInput
                                                                name="treinamento_id"
                                                                label="Treinamento"
                                                                url={`/treinamento`}
                                                                displaySelectField="treinamento"
                                                                returnField={'_id'}
                                                            />

                                                        </GroupInput>
                                                    );
                                                }}
                                                validationSchema={yup.object().shape({
                                                    treinamento_id: yup.string().required('Treinamento é obrigatório'),
                                                })}
                                            />

                                        </div>
                                    );
                                },
                            ]}
                        />
                    </div>
                </div >
            </>
        );
    }


    function TelaProvedores() {
        return (
            <div className="p-2 m-2 bg-white">
                <Grid
                    url={'/griddocument/grid84-servicos'}
                    GridTitle={'Tipos de Serviço'}
                    canEdit={System.methods.getUserRule(`alterarProvedores`)}
                    canDelete={false}
                    forceReloadAfterSave
                    GridHeaders={[{ title: 'Tipo', field: 'tipo', sort: true, className: 'w-full text-left pl-1' }]}
                    LineDataPrint={(data) => {
                        return [data.tipo];
                    }}
                    onRenderForm={(GridModes, SetFieldValue, values) => {
                        return (
                            <div>
                                <Input name="tipo" label="Tipo" />
                            </div>
                        );
                    }}
                    validationSchema={yup.object().shape({
                        tipo: yup.string().required('Tipo é obrigatório'),
                    })}
                    FormTabs={[
                        () => <div>Home</div>,
                        () => <div>Critérios</div>,
                    ]}
                    onRenderFormExtra={[
                        (GridModes, item, GridRefresh) => {
                            return (
                                <Grid
                                    url={`/griddocument/grid84-${item._id}-criterios`}
                                    GridTitle={'Critérios'}
                                    GridHeaders={[
                                        { title: 'Critério', field: 'criterio', sort: true, className: 'w-10/12 text-left pl-1' },
                                        { title: 'Peso', field: 'peso', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                        { title: 'Demérito', field: 'demerito', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                    ]}
                                    LineDataPrint={(data) => {
                                        return [data.criterio, data.peso.toString(), data.demerito.toString()];
                                    }}
                                    onRenderForm={(GridModes, SetFieldValue, values) => {
                                        return (
                                            <div>
                                                <Input name="criterio" label="Critério" />
                                                <GroupInput>
                                                    <Input type="number" name="peso" label="Peso" />
                                                    <Input type="number" name="demerito" label="Demérito" />
                                                </GroupInput>
                                            </div>
                                        );
                                    }}
                                    validationSchema={yup.object().shape({
                                        criterio: yup.string().required('Critério é obrigatório'),
                                        peso: yup.number().required('Peso é obrigatório'),
                                        demerito: yup.number().required('Demérito é obrigatório'),
                                    })}
                                />
                            );
                        },
                    ]}
                    onBeforeDelete={async (item) => {
                        await System.apiDelete(`/griddocument/grid84-${item._id}-criterios`);
                    }}
                />
            </div>
        );
    }

    function TelaTreinamentos() {
        return (
            <>
                <div className="mt-4 ml-2 bg-white rounded grow">
                    <div className="w-full border shadow">
                        <Grid
                            url={'/treinamento'}
                            GridTitle="Treinamentos aplicados a colaboradores"
                            key={uuid()}
                            canEdit={System.methods.getUserRule(`alterarTreinamentos`)}
                            canDelete={false}
                            disableModal
                            forceReloadAfterSave
                            GridHeaders={[
                                {
                                    title: 'Treinamento', field: 'treinamento', sort: true, filter: true, className: 'w-1/2 text-left pl-1'
                                }, {
                                    title: 'Periodicidade', field: 'periodicidade', sort: true, filter: true, className: 'w-1/2 text-left pl-1'
                                }, {
                                    title: 'Alerta', field: 'alerta', sort: true, filter: true, className: 'w-1/2 text-left pl-1'
                                }]}
                            LineDataPrint={(item) => {
                                return [
                                    item.treinamento,
                                    periodos.find((x) => x.value === item.periodicidade)?.option,
                                    `${item.alerta} dias`
                                ];
                            }}
                            onRenderForm={(GridModes, SetFieldValue, values) => {
                                return (
                                    <div>
                                        <GroupInput>
                                            <Input name="treinamento" label="Treinamento" />
                                        </GroupInput>
                                        <GroupInput>
                                            <SelectInput
                                                name="periodicidade"
                                                label="Periodicidade"
                                                className={'w-2/6'}
                                                listOptions={periodos}
                                            />
                                        </GroupInput>
                                        <GroupInput>
                                            <SelectInput
                                                name="alerta"
                                                label="Antecedência do alerta"
                                                className={'w-2/6'}
                                                disabled={values.periodicidade === 0}
                                                listOptions={[
                                                    { value: 10, option: '10 dias' },
                                                    { value: 30, option: '30 dias' },
                                                    { value: 60, option: '60 dias' },
                                                    { value: 90, option: '90 dias' },
                                                    { value: 180, option: '180 dias' },
                                                    { value: 365, option: '1 ano' }
                                                ]}
                                            />
                                        </GroupInput>

                                    </div>
                                );
                            }}
                            validationSchema={yup.object().shape({
                                treinamento: yup.string().required('Treinamento é obrigatório'),
                            })}
                        />
                    </div>
                </div>
            </>
        );
    }


    if (
        !System.methods.getUserRule(`menuColaboradores`) && !System.methods.getUserRule(`menuProvedores`)) {
        return <div className='block'>
            <p><span>Você não tem permissão para esta área.</span></p>
            <div className='w-32 text-center'>
                <div onClick={() => navigate('/', { replace: false })} className='p-2 m-2 border border-gray-400 cursor-pointer bg-botao-primario'>
                    Voltar
                </div>
            </div>
        </div>
    }

    if (company?.usarPermissoesEspeciais !== true) {
        return (<div>Sem permissão</div>);
    }
    return (
        <Layout>
            <div className="min-h-screen grow-0 bg-yellow-50">
                {MenuEsquerdo()}
            </div>
            <div className="grow bg-yellow-50">
                {Menu === 1 && TelaColaboradores()}
                {Menu === 2 && TelaFuncoes()}
                {Menu === 3 && TelaProvedores()}
                {Menu === 4 && TelaTreinamentos()}
            </div>
            <div className="w-20"></div>
        </Layout>
    );
};

export default Cadastros;